import { Fragment, useState } from "react";

import { MenuBook } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { black, mediumGray } from "@/common/theming/colors";

import { StaffShiftHistoryModal } from "../../StaffShiftHistoryModal";
import { TShiftEditorProps } from "../types";

export const ShiftHistory = (props: TShiftEditorProps) => {
  const { staffShift, showHistory = true } = props;

  const [historyIsOpen, setHistoryIsOpen] = useState(false);

  if (!staffShift.id || !showHistory) return null;

  return (
    <Fragment>
      <Tooltip title="Browse shift history" arrow placement="top">
        <MenuBook
          className="shift-history-icon"
          sx={{
            color: mediumGray,
            "&:hover": { color: black },
            border: `1.5px solid var(--background-color) !important`,
          }}
          onClick={(event) => {
            setHistoryIsOpen(true);
            event.stopPropagation();
          }}
        />
      </Tooltip>
      {historyIsOpen && (
        <StaffShiftHistoryModal
          staffShiftId={staffShift.id}
          onClose={() => setHistoryIsOpen(false)}
          modalTitle="Shift History"
        />
      )}
    </Fragment>
  );
};
